import { useCallback } from 'react'
import { useDispatch, useSelector } from '.'
import { ApplicationDataFull } from '../../../types/ApplicationData'
import { applicationNextAction, applicationPreviousAction, applicationSelectAction } from '../actions/uiActions'
export const useApplication = (): {
  applications: ApplicationDataFull[]
  currentApplication: ApplicationDataFull
  index: number
  nextApplication: ApplicationDataFull
  previousApplication: ApplicationDataFull
  setApplication: (application?: ApplicationDataFull | string) => void
  setIndex: (index: number) => void
  gotoNext: () => void
  gotoPrevious: () => void
  lastMovement: 'next' | 'previous' | undefined
} => {
  const applications = useSelector((state) => state.data.applications)
  const { application: current, lastMovement } = useSelector((state) => state.ui.inspiration)
  const index = applications.findIndex(({ id }) => id === current)
  const dispatch = useDispatch()

  const setApplication = useCallback(
    (application?: ApplicationDataFull | string, movementDirection?: 'previous' | 'next') => {
      const applicationId = typeof application === 'string' ? application : application?.id
      dispatch(applicationSelectAction(applicationId, movementDirection))
    },
    [dispatch]
  )
  const gotoNext = useCallback(() => dispatch(applicationNextAction()), [dispatch])
  const gotoPrevious = useCallback(() => dispatch(applicationPreviousAction()), [dispatch])
  const setIndex = useCallback(
    (index: number, movementDirection?: 'previous' | 'next') => {
      const applicationId = applications[index]?.id
      if (applicationId) {
        dispatch(applicationSelectAction(applicationId, movementDirection))
      }
    },
    [dispatch, applications]
  )

  return {
    applications,
    currentApplication: applications[index],
    index,
    nextApplication: index < applications.length - 1 ? applications[index + 1] : applications[0],
    previousApplication: index > 0 ? applications[index - 1] : applications[applications.length - 1],
    setApplication,
    setIndex,
    gotoNext,
    gotoPrevious,
    lastMovement
  }
}
